import { render, staticRenderFns } from "./pettypay.vue?vue&type=template&id=7e88a2db&"
import script from "./pettypay.vue?vue&type=script&lang=js&"
export * from "./pettypay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports